"use client";
import VisualTest from "@/containers/VisualTest/VisualTest";
import VisualTestProvider from "@/context/VisualTestContext";

export default function VisualTestPage() {
  return (
    <VisualTestProvider>
      <VisualTest />
    </VisualTestProvider>
  );
}
